
const ErrorParser = (error : any) => {
    const statusCode = error.data.statusCode;
    const message = error.data.message;

    return message;
}

export default ErrorParser